import React , { useEffect }from 'react'
//import io from 'socket.io-client'

import socketUid from './SocketUid'


// https://legaltek.digital/socket.io/

// ws://localhost:3033
// wss://legaltek.digital/legalsocket/api
// ws://localhost:3000
// wss://keratinizate.com/legalsocket/api

/*
const app = express();

const allowedOrigins = ['*'];

const options: cors.CorsOptions = {
  origin: allowedOrigins ,
  methods: ["GET", "POST"],
  credentials: true
};

// Then pass these options to cors:
app.use(cors(options));
*/

/* Licencia de pruebas para el calendarrio
https://fullcalendar.io/
var calendar = new Calendar(calendarEl, {
  schedulerLicenseKey: 'CC-Attribution-NonCommercial-NoDerivatives'
});
*/

/*

https://www.youtube.com/watch?v=fBJgzK9DV64

*/


// Video para revisar ( Sobretodo por la parte del cliente )
// https://www.youtube.com/watch?v=djMy4QsPWiI
// Aqui debemos de registrar al cliente-abogado cuando este se de loggin , sino queda como anonimo
function SocketClient() {

    useEffect(() => {

        console.log( "Vamos a abrir el websocket/legalsocket/api")


        const socket = new WebSocket('ws://localhost:3003' , socketUid() )

        socket.addEventListener("open", event => {

           var obj = {
              type: "logg", // estamos solicitando loguearlo 
              name: "anonymous", // puede ser zoom , con los datos de abajo
              position : "" , // client ( 1 ) , lawyer ( 2 )
              id : 0 , // Id del cliente o del abogado , segun el caso
              isZoom : false , // Es una sesion de zoom ???

            };

            socket.send( JSON.stringify( obj ))
          });
          
          // Listen for messages
          socket.addEventListener("message", event => {
            console.log("Message from server ", event.data)
          });
        
        //const socket = io('ws://localhost:3033')  // Esta es la conexion al socket
/*
        socket.on('connect', () => {
            console.log('Conectado al servidor de sockets');
        });

        socket.on('disconnect', () => {
            console.log('Desconectado del servidor de sockets');
        });

        socket.on('mensaje', (mensaje) => {
            console.log('Mensaje recibido:', mensaje);
        });

        socket.on('error' ,(err) =>{
            console.log( "Error en la conexion " , err )
        })

        return () => {
            socket.off('connect');
            socket.off('disconnect');
            socket.off('mensaje');
        };
*/
        socket.onopen = () => {
            console.log('Conexión abierta');
        };
    }, [])

  return (
    <div>SocketClient</div>
  )
}

export default SocketClient